import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>WHEN TO USE THE KEY QUESTIONS
                                            </div>
                                            <p>The key questions can be used when:</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li>You or your team are feeling 'stuck' about finding a
                                                        solution or new idea
                                                    </li>
                                                    <li>You need to encourage other people to be more open
                                                        minded about a situation
                                                    </li>
                                                    <li>'Reality checking' an existing process or product to
                                                        test its utility
                                                    </li>
                                                    <li>You need to stimulate your own thinking.</li>
                                                </ul>
                                            </div>
                                            <p>They can also be used to structure brainstorming or
                                                problem-solving sessions which are designed to open up
                                                people's minds to the complexity and diversity of a set of
                                                ideas or challenges, for example when dealing with
                                                significant change. </p>
                                            <div className="border_subtitle">Purpose:</div>
                                            <p>These questions seek to explore issues about 'why'. They help
                                                clarify and align the reasons why something is happening or
                                                help to define exactly what it is that needs to be achieved.
                                                Purpose questions tend to be about broad direction; they are
                                                more strategic than operational. They are a good way of
                                                opening up thinking to consider future possibilities rather
                                                than staying rooted in
                                                day-to-day operations. Examples might include: </p>
                                            <ul className="greenbullet-list">
                                                <li>What are the reasons for doing this?</li>
                                                <li>What purposes will be served by doing this?</li>
                                                <li>Why are we doing this/do we need to do this?</li>
                                                <li>Why are we doing this now?</li>
                                            </ul>
                                            <p className="para-first-pad"><span
                                                className="subtiltereg">Summary:</span> Your answers to the
                                                above questions will provide you with the initial picture of
                                                what
                                                you are doing and why. You should try to refer back to these
                                                replies so that what you do later on
                                                in the process still fits in with your overall objectives.
                                            </p>
                                            <div className="border_subtitle">Comparisons:</div>
                                            <p>These questions are designed to force consideration of
                                                experience and prior learning; they demand that you put the
                                                current issue or challenge alongside your own (or the
                                                organisation's) knowledge of what has worked or not worked
                                                previously. These questions are more than just a reality
                                                check, they make sure that ideas build rather than develop
                                                in isolation. They also ensure that all the relevant
                                                information is brought to bear on the current issue or
                                                challenge. Examples
                                                might include: </p>
                                            <ul className="greenbullet-list">
                                                <li>What happened the last time we tried this?</li>
                                                <li>Who else has done this - what did they learn?</li>
                                                <li>How is this the same (or different) from similar
                                                    situations we have experienced?
                                                </li>
                                                <li>What factors do we want to change to reach a
                                                    different/better outcome?
                                                </li>
                                            </ul>
                                            <p className="para-first-pad"><span
                                                className="subtiltereg">Summary:</span> Gathering responses
                                                to these questions ensures that you have looked into the
                                                past
                                                and considered the learning gained from experience. These
                                                questions are useful to make sure that you are not
                                                constantly trying to reinvent the wheel. It may also be that
                                                something from the
                                                past could be innovative in the current situation. </p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}